import React from 'react';
import { ClipboardCheckIcon, FileTextIcon, FilterIcon, ListChecksIcon, MapIcon, SearchIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { sevenQuestions, toolkit } from '../../data/content';
const icons: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  clipboard: ClipboardCheckIcon,
  list: ListChecksIcon,
  map: MapIcon,
  file: FileTextIcon,
  filter: FilterIcon,
  search: SearchIcon
};
export function Toolkit() {
  return <section className="bg-brand-800 px-5 py-16 sm:py-20 text-white" data-id="element-247" data-mp="2cewcdhol5abg">
      <div className="mx-auto max-w-5xl" data-id="element-248" data-mp="2cctfcdp0mgx8">
        <h2 className="text-center font-serif text-[30px] leading-tight sm:text-5xl font-extrabold" data-id="element-249" data-mp="2h533bo6kl6wv">
          Plus, the complete <em className="text-brand-200" data-id="element-250" data-mp="2m3o35mhwtoks">decision toolkit</em>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[17px] text-brand-100" data-id="element-251" data-mp="2r4c3iys13hro">
          Practical resources designed to be used alongside the six volumes.
        </p>

        <ul className="mt-10 grid gap-x-10 gap-y-7 sm:grid-cols-2 lg:grid-cols-3" data-id="element-252" data-mp="2v31hotkw53cd">
          {toolkit.map(t => {
          const Icon = icons[t.icon];
          return <li key={t.title} className="flex gap-4" data-id="element-253" data-mp="1vzjo2ijtouu9">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white/10 text-brand-200" data-id="element-254" data-mp="1qxkm9d3qe5zf">
                  <Icon className="h-6 w-6" data-id="element-255" data-mp="1m0u4mlca32bw" />
                </span>
                <div data-id="element-256" data-mp="2jnb15od6tbwl">
                  <h3 className="text-lg font-bold" data-id="element-257" data-mp="2jlq7s22lzz0b">{t.title}</h3>
                  <p className="mt-1 text-[15px] leading-snug text-brand-100" data-id="element-258" data-mp="2enewro0kvigi">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mt-14 rounded-3xl bg-white p-6 sm:p-10 text-ink" data-id="element-259" data-mp="29uvispxzalb6">
          <h3 className="text-center font-serif text-2xl sm:text-4xl font-extrabold leading-tight" data-id="element-260" data-mp="24xvas9hkj8hf">
            Any case feels more manageable when you have a process
          </h3>
          <p className="mx-auto mt-3 max-w-xl text-center text-[16px] text-muted" data-id="element-261" data-mp="2xm0wozkcz3iu">
            You don’t need to memorize the entire system. You simply start with these seven questions — the core of the Ortho
            Decision System™.
          </p>
          <ol className="mx-auto mt-8 max-w-xl space-y-3" data-id="element-262" data-mp="lzgwd5lgkz5l">
            {sevenQuestions.map((q, i) => <li key={q} className="flex items-center gap-4 rounded-2xl bg-brand-50 p-3 pr-4" data-id="element-263" data-mp="qyadd7zyf8ai" data-mpi={i}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-700 font-serif text-lg font-bold text-white" data-id="element-264" data-mp="cz0we63xca5h">
                  {i + 1}
                </span>
                <span className="text-[16px] sm:text-lg font-semibold leading-snug" data-id="element-265" data-mp="30utpmaamzzk">{q}</span>
              </li>)}
          </ol>
        </div>

        <div className="mt-10" data-id="element-266" data-mp="807pwxn21jet">
          <CtaButton label="I want access to the complete system" data-id="element-267" data-mp="1xemcpceiiw7o" />
        </div>
      </div>
    </section>;
}